import styled, { css } from '../../../consts/styled';

import { colors, PRIMARY_FONT_FAMILY, spacing } from '../../../App/ChakraTheme';
import { VStack } from '@chakra-ui/react';

export const NavigationSidebarContainer = styled(VStack)`
  background-color: ${colors.whitesmoke};
  width: ${(props) => (props.user ? '230px' : '302px')};
  padding: ${spacing.SMALL};
  position: fixed;
  top: 28px;
  right: 12px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.15);
  border-radius: 4px;

  & svg g path:nth-child(2) {
    // fill: ${colors.white};
  }

  & .sidebar-close-icon svg g path:nth-child(2) {
    stroke: ${colors.persianblue};
    stroke-width: 1px;
  }

  & .row-cs.chakra-stack.icons {
    margin-bottom: ${spacing.TINY};
    width: 100%;
  }

  & hr {
    margin: 0;
    opacity: 0.5;
    border-top: 0px;
    border-color: ${colors.persianblue};
  }

  & hr.navigation-links-separator {
    margin: ${spacing.TINY} 0;

    &.first-child {
      margin-top: 0;
    }

    &.last-child {
      margin-bottom: 0;
    }
  }

  & a.navigation-link {
    width: fit-content;
  }

  & a.account-navigation-link {
    opacity: 0.9;
    width: fit-content;
    ${css`
      fontFamily: ${PRIMARY_FONT_FAMILY},
      fontWeight: 600,
      fontStyle: normal,
      fontStretch: normal,
      fontSize: 15px,
      lineHeight: 2.13,
      letterSpacing: normal,
      // color: ${colors.white};
    `};
  }

  & a.account-navigation-link:last-child {
    margin-bottom: ${spacing.SMALL};
    opacity: 0.5;
  }

  & a.account-navigation-link:first-child {
    margin-top: ${spacing.SMALL};
  }

  & .row-cs.chakra-stack.account-information {
    height: ${spacing.XLARGE_PLUS};
  }

  & .row-cs.chakra-stack.account-information svg {
    margin-left: ${spacing.BASE};
    margin-right: ${spacing.SMALL};
  }

  & .row-cs.chakra-stack.account-information .footer-category-text {
    opacity: 0.5;
    margin-top: 1px;
  }

  & div.account-navigation {
    flex: unset;
    background-color: ${colors.persianblue};
  }

  & h4,
  .footer-category-text,
  .footer-section-text {
    // color: ${colors.white};
  }

  & a {
    display: inline-flex;
    text-decoration: none;
  }
`;
